import React, { useState } from "react";
import styles from "./payoutViewModal.module.css";
import { Button } from "@mui/material";
import AttachmentPreviewModal from "../AttachmentPreviewMOdal/AttachmentPreviewModal";
import { useAllProduct } from "../../../api-context/commonApiContext";
import config from "../../../service/config";
import RejectReasonModal from "./PayoutRejectModal/PayoutRejectModal";

const PayoutViewModal = ({
  onClose,
  selectedRowVal = {},
  setUserAdded,
  setRefreshData,
  setPayoutDetails,
}) => {
  const {
    role,
    approverLimit,
    clientId,
    selectedCompanyName,
    selectedEscrowName,
  } = useAllProduct();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const {
    created_at,
    created_by,
    beneficiary_name,
    amount,
    bank_account,
    transaction_note,
    internal_note,
    utr,
    status,
    rejection_reason,
    id,
  } = selectedRowVal;

  const statusStyle = {
    REJECTED: styles.statusRejected,
    SUCCESS: styles.statusSuccess,
    "APPROVED L1": styles.statusApproved,
    "APPROVED L2": styles.statusApproved,
  };

  const handleAccept = async (actionType, reason) => {
    try {
      const statusValue =
        actionType === "accept"
          ? role.toString() === "Owner"
            ? "Completed"
            : role.toString() === "Approver L1"
            ? "Approved L1"
            : role.toString() === "Approver L2"
            ? "Approved L2"
            : role.toString() === "Maker"
            ? "Pending"
            : "Completed"
          : "REJECTED";

      const payload = {
        payout_id: id,
        status: statusValue,
        client_id: clientId,
        selectedCompanyName,
        selectedEscrowName,
      };

      if (actionType === "accept") {
        payload.approved_by = role.toString();
      } else {
        payload.rejected_by = role.toString();
        payload.rejection_reason = reason || "";
      }
      console.log("payload-->", payload);

      const response = await fetch(
        `${config.node_api_endpoint}/api/payout-approve`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result.success) {
        setRefreshData(true);
        alert(
          actionType === "accept"
            ? "Payout approved successfully."
            : "Payout rejected."
        );

        setPayoutDetails((prev) =>
          prev.map((item) =>
            item.id === id
              ? {
                  ...item,
                  status: payload.status,
                  ...(actionType === "accept"
                    ? { approved_by: payload.approved_by }
                    : {
                        rejected_by: payload.rejected_by,
                        rejection_reason: payload.rejection_reason,
                      }),
                }
              : item
          )
        );
        onClose();
      } else {
        console.error("Failed:", result.message);
      }
    } catch (err) {
      console.error("Error during PUT call:", err);
    }
  };

  console.log(selectedRowVal);

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modalContainer}>
        <div className={`${styles.modalHeader} gap-2`}>
          <button className={styles.closeButton} onClick={onClose}>
            &times;
          </button>
          <h2>Payout details</h2>
        </div>

        <div className={`mt-3`}>
          <div className={`d-flex mb-2 text-align-center`}>
            <div className={`${styles.label} w-50`}>CREATED AT</div>
            <div className={styles.value}>{created_at}</div>
          </div>
          <div className={`d-flex align-items-center mb-2`}>
            <span className={`${styles.label} w-50`}>BENEFICIARY NAME</span>
            <span className={styles.value}>{beneficiary_name}</span>
          </div>
          <div className={`d-flex align-items-center mb-2`}>
            <span className={`${styles.label} w-50`}>AMOUNT</span>
            <span className={styles.value}>₹{amount}</span>
          </div>
          <div className={`d-flex align-items-center mb-2`}>
            <span className={`${styles.label} w-50`}>A/CNO - UPI ID</span>
            <span className={styles.value}>{bank_account}</span>
          </div>
          <div className={`d-flex align-items-center mb-2`}>
            <span className={`${styles.label} w-50`}>TRANSACTION NOTE</span>
            <span className={styles.value}>{transaction_note}</span>
          </div>
          <div className={`d-flex align-items-center mb-2`}>
            <span className={`${styles.label} w-50`}>REMARKS</span>
            <span className={styles.value}>{internal_note || "-"}</span>
          </div>
          <div className={`d-flex align-items-center mb-2`}>
            <span className={`${styles.label} w-50`}>UTR</span>
            <span className={styles.value}>{utr}</span>
          </div>
          <div className={`d-flex align-items-center mb-2`}>
            <span className={`${styles.label} w-50`}>TXN STATUS</span>
            <span className={`${styles.statusBadge} ${statusStyle[status]}`}>
              {status === "Owner" ? "COMPLTED" : status}
            </span>
          </div>
          {rejection_reason && (
            <div className={`d-flex align-items-center mb-2`}>
              <span className={`${styles.label} w-50`}>Rejection Reason</span>
              <span className={`${styles.statusBadge} ${statusStyle[status]}`}>
                {rejection_reason}
              </span>
            </div>
          )}
        </div>

        <h4 className={styles.sectionTitle}>Bill Attachment</h4>
        {/* <div className={styles.attachmentList}>
          {[1, 2, 3, 4].map((n) => (
            <div key={n} className={styles.attachmentItem}>
              <div className={styles.attachmentLabel}>
                <img src="/attachment.svg" alt="attachment" />
                <span>
                  20241122144947CUPI8456123498({n})<br />
                  {n === 1
                    ? "Bill Resubmitted"
                    : n === 2
                    ? "Resubmit Bill Requested"
                    : ""}
                </span>
              </div>
              <Button
                variant="contained"
                sx={{
                  background: "#2348AB",
                  textTransform: "none",
                  padding: "4px 16px",
                }}
                onClick={() => {
                  setPreviewFile({
                    fileName: `20241122144947CUPI8456123498(${n})`,
                    reason:
                      n === 2
                        ? "Image quality is not clear. To send, image quality must be improved."
                        : null,
                  });
                  setPreviewOpen(true);
                }}
              >
                View
              </Button>
            </div>
          ))}
        </div> */}
        {selectedRowVal.receipt_files?.length > 0 ? (
          <div className={styles.attachmentList}>
            {selectedRowVal.receipt_files.map((filePath, index) => {
              const fileName = filePath.split("/").pop();
              return (
                <div key={index} className={styles.attachmentItem}>
                  <div className={styles.attachmentLabel}>
                    <img src="/attachment.svg" alt="attachment" />
                    <span>{fileName}</span>
                  </div>
                  <Button
                    variant="contained"
                    sx={{
                      background: "#2348AB",
                      textTransform: "none",
                      padding: "4px 16px",
                    }}
                    onClick={() => {
                      setPreviewFile({
                        fileName: fileName, // only the name
                        reason: null,
                      });
                      setPreviewOpen(true);
                    }}
                  >
                    View
                  </Button>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-muted" style={{ marginLeft: "12px" }}>
            No attachments uploaded.
          </p>
        )}

        <div className={styles.footerActions}>
          {(created_by === "Maker" &&
            role.toString() === "Approver L1" &&
            status === "Pending" &&
            approverLimit > Number(amount)) ||
          (created_by === "Maker" &&
            role.toString() === "Approver L2" &&
            status === "Approved L1" &&
            approverLimit > Number(amount)) ||
          (status === "Pending" && role.toString() === "Owner") ||
          (role.toString() === "Super Admin" &&
            status === "Pending" &&
            approverLimit > Number(amount)) ||
          (role.toString() === "Admin" &&
            status === "Pending" &&
            approverLimit > Number(amount)) ? (
            <>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#2348AB", borderRadius: "8px" }}
                onClick={() => {
                  handleAccept("accept", "");
                }}
              >
                ✓ Approve Spend
              </Button>
              <Button
                variant="outlined"
                sx={{
                  color: "#2348AB",
                  borderColor: "#2348AB",
                  borderRadius: "8px",
                  marginLeft: "16px",
                }}
                onClick={() => {
                  // setSelectedRowVal(report);
                  setShowRejectModal(true);
                }}
              >
                ✕ Reject Spend
              </Button>
            </>
          ) : (
            ""
          )}
        </div>
        {previewOpen && (
          <AttachmentPreviewModal
            fileName={previewFile.fileName}
            reason={previewFile.reason}
            onClose={() => setPreviewOpen(false)}
          />
        )}
        {showRejectModal && (
          <RejectReasonModal
            onClose={() => setShowRejectModal(false)}
            onSave={(reason) => {
              console.log("Rejection reason:", reason);
              handleAccept(selectedRowVal, "reject", reason);
              // Trigger reject API or update
            }}
          />
        )}
      </div>
    </div>
  );
};

export default PayoutViewModal;
